'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:VerifyEmailCtrl
 * @description
 * # VerifyEmailCtrl
 * Controller for the email verification page.
 */
angular.module('360StoreAngularApp')
	.controller('VerifyEmailCtrl', function ($scope, $location, $timeout, api) {

		$scope.verificationStatus = 'verifying'; // 'verifying', 'success', 'error'
		$scope.errorMessage = 'An unknown error occurred.';

		// Function to call the API
		function verifyToken(token) {
			api.verifyAccount({token: token}) // Pass token in the body
				.then(function (response) {
					$scope.verificationStatus = 'success';
					toastr.success(response.message || 'Email verified successfully. Please log in.', 'Verification Successful');

					// Redirect to login page after a short delay
					$timeout(function () {
						$location.path('/login').search({verified: 'true'}); // Add query param
					}, 3000); // 3-second delay
				})
				.catch(function (error) {
					$scope.verificationStatus = 'error';
					if (error && error.data && error.data.error) {
						$scope.errorMessage = error.data.error;
					} else if (error && error.statusText) {
						$scope.errorMessage = 'Verification failed: ' + error.statusText;
					} else {
						$scope.errorMessage = 'Verification failed. The link may be invalid or expired.';
					}
					toastr.error($scope.errorMessage, 'Verification Failed');
				});
		}

		// On controller load, get token from URL and attempt verification
		const tokenFromUrl = $location.search().token;

		if (tokenFromUrl) {
			verifyToken(tokenFromUrl);
		} else {
			$scope.verificationStatus = 'error';
			$scope.errorMessage = 'No verification token found in the URL.';
			toastr.error($scope.errorMessage, 'Verification Failed');
		}

		// Optional: If you implement a resend verification feature on this page
		// $scope.resendVerification = function() { ... }
	});
